// extracted by mini-css-extract-plugin
module.exports = {"TitleSection":"ResetPassword__TitleSection__1dXF"};